import React, { useState, useEffect, useRef } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { toast } from 'react-toastify';
import { CallApi } from "../../../Components/common/CommonFunctions.js";

const QuotationOrgSettings = () => {
    const [formData, setFormData] = useState({});
    const [recordId, setRecordId] = useState(null);
    const isMounted = useRef(false);
    const [disLoading, setDisLoading] = useState(false);

    const handleGetOrg = () => {
         setDisLoading(true);
         CallApi({
            endPoint: 'quotation/get-org-local-charges',
            method: 'get',
            onSuccess: (res) => {
                const resCode = res.data.response_code;
                if (resCode === 200) {
                    const innerData = res.data.response_data;
                    if (innerData) {
                        setRecordId(innerData.record_id || null);
                        setFormData(innerData);
                    }
                    setDisLoading(false);
                } else {
                    toast.error("Error Fetching");
                    setDisLoading(false);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    useEffect(() => {
     if (isMounted.current) return;
        handleGetOrg();
     isMounted.current = true;
    }, []);

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = () => {
        setDisLoading(true);
        const payload = { ...formData };
        CallApi({
            endPoint: 'quotation/submit-org-local-charges',
            payload,
            onSuccess: (res) => {
                const resCode = res.data.response_code;
                if (resCode === 200) {
                    toast.success('Settings saved successfully');
                    const innerData = res.data.response_data;
                    setDisLoading(false);
                }
                else {
                    toast.error(res.data.response_msg || "Error saving changes");
                    setDisLoading(false);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    return (
        <>  
             {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            <div className='col-9 col-xxl-9 stting_right'>
                <div className='settingbg_right Q_orgsetting'>

                    <Row>
                        {/* ══════════════ LEFT: EXPORT ══════════════ */}
                        <Col sm={6} className="border-end pe-4">

                            <h4>Export</h4>

                            {/* 1. Terminal Handling Charges (Export) */}
                            <h6>1. Terminal Handling Charges (Export)</h6>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Minimum (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 75"
                                        value={formData.export_terminal_min || ''}
                                        onChange={(e) => handleChange('export_terminal_min', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Maximum (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 315"
                                        value={formData.export_terminal_max || ''}
                                        onChange={(e) => handleChange('export_terminal_max', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Rate 1–1000 kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.08"
                                        value={formData.export_terminal_rate_1 || ''}
                                        onChange={(e) => handleChange('export_terminal_rate_1', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Rate 1001–2000 kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.08"
                                        value={formData.export_terminal_rate_2 || ''}
                                        onChange={(e) => handleChange('export_terminal_rate_2', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={5}>Rate 2001+ kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.07"
                                        value={formData.export_terminal_rate_3 || ''}
                                        onChange={(e) => handleChange('export_terminal_rate_3', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <hr />

                            {/* 2. KLN Warehouse Handling (Export) */}
                            <h6>2. KLN Warehouse Handling (Export)</h6>

                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={5}>Fixed Fee per AWB (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 50"
                                        value={formData.export_warehouse_fixed || ''}
                                        onChange={(e) => handleChange('export_warehouse_fixed', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <hr />

                            {/* 3. AWB / Admin Fee (Export) */}
                            <h6>3. AWB / Admin Fee (Export)</h6>

                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={5}>Fixed Fee per AWB (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 30"
                                        value={formData.export_awb_fee || ''}
                                        onChange={(e) => handleChange('export_awb_fee', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <hr />

                            {/* 4. Customs Clearance (Export) */}
                            <h6>4. Customs Clearance (Export)</h6>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Fixed Fee incl. 2 HS Codes (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 50"
                                        value={formData.export_customs_fixed || ''}
                                        onChange={(e) => handleChange('export_customs_fixed', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={5}>Extra HS Code Rate (EUR each)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 6"
                                        value={formData.export_customs_extra_hs || ''}
                                        onChange={(e) => handleChange('export_customs_extra_hs', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <hr />

                            {/* 5. Pick-Up in the Netherlands (Export) */}
                            <h6>5. Pick-Up in the Netherlands (Export)</h6>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Minimum (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 75"
                                        value={formData.export_pickup_min || ''}
                                        onChange={(e) => handleChange('export_pickup_min', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Maximum (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 700"
                                        value={formData.export_pickup_max || ''}
                                        onChange={(e) => handleChange('export_pickup_max', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Rate 1–1000 kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.19"
                                        value={formData.export_pickup_rate_1 || ''}
                                        onChange={(e) => handleChange('export_pickup_rate_1', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Rate 1001–2000 kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.18"
                                        value={formData.export_pickup_rate_2 || ''}
                                        onChange={(e) => handleChange('export_pickup_rate_2', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Rate 2001+ kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.17"
                                        value={formData.export_pickup_rate_3 || ''}
                                        onChange={(e) => handleChange('export_pickup_rate_3', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={5}>Fuel Surcharge (%)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 26"
                                        value={formData.export_pickup_fuel || ''}
                                        onChange={(e) => handleChange('export_pickup_fuel', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                        </Col>

                        {/* ══════════════ RIGHT: IMPORT ══════════════ */}
                        <Col sm={6} className="ps-4">

                            <h4 className="fw-bold mb-3">Import</h4>

                            {/* 1. Terminal Handling Charges (Import) */}
                            <h6>1. Terminal Handling Charges (Import)</h6>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Minimum (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 75"
                                        value={formData.import_terminal_min || ''}
                                        onChange={(e) => handleChange('import_terminal_min', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Rate 1–1000 kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.24"
                                        value={formData.import_terminal_rate_1 || ''}
                                        onChange={(e) => handleChange('import_terminal_rate_1', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Rate 1001–2000 kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.24"
                                        value={formData.import_terminal_rate_2 || ''}
                                        onChange={(e) => handleChange('import_terminal_rate_2', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={5}>Rate 2001+ kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.23"
                                        value={formData.import_terminal_rate_3 || ''}
                                        onChange={(e) => handleChange('import_terminal_rate_3', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <hr />

                            {/* 2. KLN Warehouse Handling (Import) */}
                            <h6>2. KLN Warehouse Handling (Import)</h6>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Rate (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.07"
                                        value={formData.import_warehouse_rate || ''}
                                        onChange={(e) => handleChange('import_warehouse_rate', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Minimum (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 45"
                                        value={formData.import_warehouse_min || ''}
                                        onChange={(e) => handleChange('import_warehouse_min', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={5}>Maximum (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 315"
                                        value={formData.import_warehouse_max || ''}
                                        onChange={(e) => handleChange('import_warehouse_max', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <hr />

                            {/* 3. AWB / Admin Fee (Import) */}
                            <h6>3. AWB / Admin Fee (Import)</h6>

                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={5}>Fixed Fee per AWB (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 30"
                                        value={formData.import_awb_fee || ''}
                                        onChange={(e) => handleChange('import_awb_fee', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <hr />

                            {/* 4. Customs Clearance (Import) */}
                            <h6>4. Customs Clearance (Import)</h6>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Fixed Fee incl. 2 HS Codes (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 85"
                                        value={formData.import_customs_fixed || ''}
                                        onChange={(e) => handleChange('import_customs_fixed', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={5}>Extra HS Code Rate (EUR each)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 6"
                                        value={formData.import_customs_extra_hs || ''}
                                        onChange={(e) => handleChange('import_customs_extra_hs', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <hr />

                            {/* 5. Delivery in the Netherlands (Import) */}
                            <h6>5. Delivery in the Netherlands (Import)</h6>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Minimum (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 75"
                                        value={formData.import_delivery_min || ''}
                                        onChange={(e) => handleChange('import_delivery_min', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Maximum (EUR)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 700"
                                        value={formData.import_delivery_max || ''}
                                        onChange={(e) => handleChange('import_delivery_max', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Rate 1–1000 kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.19"
                                        value={formData.import_delivery_rate_1 || ''}
                                        onChange={(e) => handleChange('import_delivery_rate_1', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Rate 1001–2000 kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.18"
                                        value={formData.import_delivery_rate_2 || ''}
                                        onChange={(e) => handleChange('import_delivery_rate_2', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Rate 2001+ kg (EUR/kg)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 0.17"
                                        value={formData.import_delivery_rate_3 || ''}
                                        onChange={(e) => handleChange('import_delivery_rate_3', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2 align-items-center">
                                <Form.Label column sm={5}>Fuel Surcharge (%)</Form.Label>
                                <Col sm={7}>
                                    <Form.Control
                                        type="number"
                                        placeholder="e.g. 26"
                                        value={formData.import_delivery_fuel || ''}
                                        onChange={(e) => handleChange('import_delivery_fuel', e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                        </Col>
                    </Row>

                    {/* ── Submit Button ── */}
                    <Form.Group as={Row} className="mb-3 mt-2">
                        <Col sm="12" className="d-flex justify-content-end">
                            <Button variant="primary" onClick={handleSubmit}>
                                Submit
                            </Button>
                        </Col>
                    </Form.Group>

                </div>
            </div>
        </>
    );
};

export default QuotationOrgSettings;